import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import { Approutes } from './app/app-routing.module';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthTokenInterceptor } from './app/auth-token.interceptor';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { DebugService } from './app/services/debug.service';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';
import { PRIMENG_ES_TRANSLATION } from './app/shared/primeng-es-translation';

if (environment.production) {
  enableProdMode();
}

const debug = new DebugService();

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserAnimationsModule,
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      NgbModule,
      NgSelectModule,
      TableModule,
      ButtonModule,
      InputTextModule,
      NgOptimizedImage
    ),
    providePrimeNG({
      ripple: true,
      translation: PRIMENG_ES_TRANSLATION,
      theme: {
        preset: Lara,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    provideRouter(Approutes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true }
  ]
}).catch(err => debug.error_log(err));



